import script from "./ModesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ModesSection.vue?vue&type=script&setup=true&lang=js"

import "./ModesSection.vue?vue&type=style&index=0&id=388ff854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388ff854"]])

export default __exports__